import { makeStyles } from '@mui/styles'
import { PuiDialog, type PuiDialogProps } from '@pbt/pbt-ui-components'

import EmailChargeSheet, {
  type EmailChargeSheetProps,
} from './EmailChargeSheet'

const useStyles = makeStyles(
  () => ({
    paper: {
      width: 650,
      maxWidth: 650,
    },
  }),
  { name: 'EmailChargeSheetDialog' },
)

export interface EmailChargeSheetDialogProps
  extends EmailChargeSheetProps, PuiDialogProps {}

const EmailChargeSheetDialog = ({
  open,
  onClose,
  onOk,
  ...rest
}: EmailChargeSheetDialogProps) => {
  const classes = useStyles()

  const handleOk = () => {
    if (onOk) {
      onOk()
    }
    if (onClose) {
      onClose()
    }
  }

  return (
    <PuiDialog
      aria-labelledby="email-charge-sheet-dialog"
      classes={{
        paper: classes.paper,
      }}
      open={open}
      onClose={onClose}
    >
      <EmailChargeSheet onOk={handleOk} {...rest} />
    </PuiDialog>
  )
}

export default EmailChargeSheetDialog
